import { resolveAPIBaseURL } from "@/shared/api/backend";

const configuredWebSocketUrl = (import.meta.env.VITE_WS_URL as string | undefined)?.trim() ?? "";

export function resolveWebSocketURL(path = "/ws") {
    if (configuredWebSocketUrl) {
        return configuredWebSocketUrl;
    }

    const apiBaseURL = resolveAPIBaseURL();
    if (apiBaseURL.startsWith("http://") || apiBaseURL.startsWith("https://")) {
        const url = new URL(apiBaseURL);
        url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
        url.pathname = path;
        url.search = "";
        url.hash = "";
        return url.toString();
    }

    if (typeof window === "undefined") {
        return "";
    }

    const url = new URL(path, window.location.origin);
    url.protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    return url.toString();
}
